export const listOfLightBackgrounds: string[] = [
  '#F3EBF4'
];